import type {
  DividerProps as ChakraDividerProps,
  ThemingProps,
} from '@chakra-ui/react';
import {
  AbsoluteCenter,
  Divider as ChakraDivider,
  chakra,
} from '@chakra-ui/react';
import type { ReactNode } from 'react';
import React from 'react';

import { customColors } from '../../theme/customColors';
import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

type ForwardedProps = OmitChakraProps<
  ChakraDividerProps,
  Exclude<keyof ThemingProps, 'orientation'>
>;

export interface DividerProps extends ForwardedProps {
  label?: ReactNode;
  labelBg?: keyof typeof customColors.bg;
  ref?: React.Ref<HTMLHRElement>;
}

export const Divider = withChakraAs<DividerProps, 'hr'>(
  ({
    label,
    labelBg = 'primary',
    orientation = 'horizontal',
    ref,
    ...props
  }) => {
    if (orientation === 'horizontal' && label) {
      return (
        <chakra.div __css={{ position: 'relative' }} {...props}>
          <ChakraDivider orientation={orientation} ref={ref} />
          <AbsoluteCenter
            sx={{
              px: 2.5,
              bg: customColors.bg[labelBg],
              color: customColors.text.secondary,
              fontWeight: 'semibold',
              fontSize: 'sm',
              lineHeight: 'sm',
            }}
          >
            {label}
          </AbsoluteCenter>
        </chakra.div>
      );
    }

    return <ChakraDivider {...props} orientation={orientation} ref={ref} />;
  },
);
